import { UpgradeOffer } from '@pubstack/common/src/upgrade'
import { FunctionComponent } from 'react'
import { PageContent } from '~/components/PageContent'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { OffersUpsellPanel } from './OffersUpsellPanel'
import { UpgradeLockedPanel } from './UpgradeLockedPanel'

/**
 * A whole page the scope cannot use yet, in place of the Forbidden it used to get. Keeping the
 * breadcrumbs means the page still says which part of the product this is, rather than reading as an error.
 *
 * The subtitle is dropped, though: it belongs to the route, and the route's is written for the page
 * that would have rendered — "Create and manage rules that will be used in stacks" over a padlock
 * tells the reader to do the one thing this page exists to say they cannot.
 *
 * Two shapes, because a route is refused for one of two reasons. One product missing is a specific
 * refusal with a specific answer, so it gets the offer over a drawing of the page. Every product missing
 * is not a refusal at all — the reader has not bought anything yet and is not being told about one
 * locked door — so it gets the catalogue, which is written for exactly that reader.
 */
export const UpgradePage: FunctionComponent<{ offers: UpgradeOffer[] }> = ({ offers }) => {
  const breadcrumbs = useBreadcrumbs(undefined, { withSubtitle: false })

  return <PageContent breadcrumbs={breadcrumbs}>{offers.length === 1 ? <UpgradeLockedPanel offers={offers} /> : <OffersUpsellPanel trackingLabel={'common-upgrade-inventory-request'} />}</PageContent>
}
